var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 50,
    height: 50,
    rx: 5,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 37.5C16.8125 37.5 16.2242 37.2554 15.735 36.7663C15.2458 36.2771 15.0008 35.6883 15 35V22.5C15 21.8125 15.245 21.2242 15.735 20.735C16.225 20.2458 16.8133 20.0008 17.5 20H18.75V17.5C18.75 15.7708 19.3596 14.2971 20.5788 13.0788C21.7979 11.8604 23.2717 11.2508 25 11.25C26.7283 11.2492 28.2025 11.8588 29.4225 13.0788C30.6425 14.2988 31.2517 15.7725 31.25 17.5V20H32.5C33.1875 20 33.7763 20.245 34.2663 20.735C34.7563 21.225 35.0008 21.8133 35 22.5V35C35 35.6875 34.7554 36.2763 34.2663 36.7663C33.7771 37.2563 33.1883 37.5008 32.5 37.5H17.5ZM25 31.25C25.6875 31.25 26.2762 31.0054 26.7663 30.5163C27.2563 30.0271 27.5008 29.4383 27.5 28.75C27.4992 28.0617 27.2546 27.4733 26.7663 26.985C26.2779 26.4967 25.6892 26.2517 25 26.25C24.3108 26.2483 23.7225 26.4933 23.235 26.985C22.7475 27.4767 22.5025 28.065 22.5 28.75C22.4975 29.435 22.7425 30.0238 23.235 30.5163C23.7275 31.0088 24.3158 31.2533 25 31.25ZM21.25 20H28.75V17.5C28.75 16.4583 28.3854 15.5729 27.6562 14.8438C26.9271 14.1146 26.0417 13.75 25 13.75C23.9583 13.75 23.0729 14.1146 22.3438 14.8438C21.6146 15.5729 21.25 16.4583 21.25 17.5V20Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureIcon);
export default __webpack_public_path__ + "static/media/secure-icon.94927ef33364a3156236c4457a757981.svg";
export { ForwardRef as ReactComponent };